<template>
  <div class="wrap">
    <slot />
  </div>
</template>

<style lang="scss">
  :root,
  :host {
    --wrap-max-width: 1260px;
    --wrap-min-width: 950px;
    --wrap-offset: 20px;

    @include tablet {
      --wrap-max-width: 100%;
      --wrap-min-width: 100%;
    }
  }
</style>

<style lang="scss" scoped>
  .wrap {
    width: 100%;
    min-width: var(--wrap-min-width);
    max-width: var(--wrap-max-width);
    margin: 0 auto;
    padding: 0 var(--wrap-offset);

    @include tablet {
      box-sizing: border-box;
    }
  }
</style>
